import Vue from 'vue';
import SaasLoading from './saas-loading.vue';
import { createGuid } from '@/utils/tools.js';
const ctx = '@@saasLoadingContext'
const closeDelay = 300
const Mask = Vue.extend(SaasLoading);
const initLoading = (el) => {
    el.dataset.loadingId = createGuid()
    el[ctx] = {}
}
const removeCloseLoadingDelay = (el) => {
    if (!el[ctx]) return
    if (el[ctx].removeLoadingDelay) {
        clearTimeout(el[ctx].removeLoadingDelay)
    }
    el[ctx].removeLoadingDelay = undefined
}
const addLoading = (el, config = {}) => {
    if (window.getComputedStyle(el).position === 'static') {
        el.classList.add('custom-loading-parent-relative')
    }
    el.classList.add('custom-loading-parent-pointer-events-none')
    el.classList.add('custom-loading-parent-overflow-hidden')
    let mask = new Mask({
        el: document.createElement('div'),
        propsData: {
            loadingText: config['loading-text'],
            loadingTextColor: config['loading-text-color'],
            simple: config['simple'],
            textless: config['textless'],
            loadingCustomImage: config['loading-custom-image'],
            loadingBackground: config['loading-background'],
            loadingSpinner: config['loading-spinner'],
        },
    });
    mask.$el.id = `custom-loading-${el.dataset.loadingId}`
    if (el.scrollTop != 0) {
        mask.$el.style.top = `${el.scrollTop}px`;
    }
    if (el.scrollLeft != 0) {
        mask.$el.style.left = `${el.scrollLeft}px`;
    }
    //再添加loading
    el.appendChild(mask.$el);
    mask.$destroy();
    mask = undefined
}
// 移除loading效果
const removeLoading = (el) => {
    el.classList.remove('custom-loading-parent-relative')
    el.classList.remove('custom-loading-parent-pointer-events-none')
    el.classList.remove('custom-loading-parent-overflow-hidden')

    let loadingDom = el.querySelector(`#custom-loading-${el.dataset.loadingId}`);
    if (loadingDom) {
        loadingDom.parentElement.removeChild(loadingDom);
    }
}
// 打开loading
export const openLoading = (el, config) => {
    // 先关闭loading
    closeLoading(el, true)
    // 初始化loading
    initLoading(el)
    // 记录loading效果插入时间
    el[ctx].insertLoadingTime = new Date().getTime()
    // 添加loading效果
    addLoading(el, config)
}
// 关闭loading
export const closeLoading = (el, immediately = false) => {
    // 如果添加loading时间和移除loading时间小于300ms，则延迟移除loading效果
    if (!immediately && el[ctx] && el[ctx].insertLoadingTime && (new Date().getTime() - el[ctx].insertLoadingTime < closeDelay)) {
        el[ctx].removeLoadingDelay = setTimeout(() => {
            removeLoading(el)
            // 如果有延迟关闭，则清除timeout
            removeCloseLoadingDelay(el)
            delete el.dataset.loadingId
            delete el[ctx]
        }, closeDelay - (new Date().getTime() - el[ctx].insertLoadingTime));
    } else {
        removeLoading(el)
        // 如果有延迟关闭，则清除timeout
        removeCloseLoadingDelay(el)
        delete el.dataset.loadingId
        delete el[ctx]
    }
}
